// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bt-access-info__description[data-v-42f9fe7b]{font-size:.875rem;line-height:1.25rem}.bt-access-info__pin-code[data-v-42f9fe7b]{font-size:1.125rem;font-weight:500;letter-spacing:1em;line-height:1.75rem;margin-top:2rem;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
